import type { TRuleWithTheme } from '@ackee/fela';

import starsBg from '../../../../static/images/loader/background.png';
import { BackgroundMode } from './constants';

export const container: TRuleWithTheme<{ backgroundCSS: string; backgroundMode: BackgroundMode }> = ({
    backgroundCSS,
    backgroundMode,
}) => ({
    backgroundImage: `${backgroundMode === BackgroundMode.Dark ? `url(${starsBg})` : 'none'}, ${backgroundCSS}`,
    backgroundSize: 'contain, 4.5rem',
    position: 'relative',
    zIndex: 0,
});
